module.exports = __webpack_public_path__ + "img/egg_planes.6d7faa65.svg";